import { Box, Flex, Icon, IconButton } from '@chakra-ui/react';
import { flexRender, Header, Table as ReactTable } from '@tanstack/react-table';
import { BsFillCaretDownSquareFill, BsFillCaretUpSquareFill, BsFillDashSquareFill } from 'react-icons/bs';

import { ColumnFilter } from './ColumnFilter';

// Sort/filter affordances shared by every cip table header cell - keep this the one place that
// changes when those affordances change, even for tables (e.g. PositionLifeCycleGrid) that render
// their own <Th> wrapper for sticky/accent/colSpan behavior.
export const TableHeaderCellContent = <T,>({ header, table }: { header: Header<T, unknown>; table: ReactTable<T> }) => (
    <Flex alignItems="center" gap={1}>
        <Box color={header.column.getIsSorted() || header.column.getIsFiltered() ? 'teal.200' : ''}>
            {flexRender(header.column.columnDef.header, header.getContext())}
        </Box>
        {(header.column.getCanFilter() || header.column.getCanSort()) && (
            <Flex ml="auto">
                {header.column.getCanFilter() ? (
                    <Box color="whiteAlpha.900">
                        <ColumnFilter column={header.column} table={table} />
                    </Box>
                ) : null}
                {header.column.getCanSort() ? (
                    <IconButton
                        onClick={header.column.getToggleSortingHandler()}
                        aria-label="sort"
                        size="xs"
                        variant="ghost"
                        icon={
                            {
                                asc: <Icon as={BsFillCaretUpSquareFill} color="teal.200" />,
                                desc: <Icon as={BsFillCaretDownSquareFill} color="teal.200" />,
                            }[header.column.getIsSorted() as string] ?? (
                                <Icon color="gray.400" as={BsFillDashSquareFill} />
                            )
                        }
                    />
                ) : null}
            </Flex>
        )}
    </Flex>
);
